import { formatPointsAsCurrency } from 'shared/utils/money';
import { convertCurrencyToPoints, convertPointsToCurrency } from 'shared/utils/points-exchange';

export const convertPointsToLocalCurrency = (points: number, usdExchangeRate: number): number =>
  convertPointsToCurrency(points, usdExchangeRate);

export const convertLocalCurrencyToPoints = (amount: number, usdExchangeRate: number): number =>
  convertCurrencyToPoints(amount, usdExchangeRate);

export const formatPointsToLocalCurrency = (
  points: number,
  currencyCode: string,
  usdExchangeRate: number,
  locale?: string
): string => formatPointsAsCurrency(points, currencyCode, usdExchangeRate, locale);
